import get from "lodash.get";
import dict from "./dictionary";

function translate(strings, ...values) {
  const r = strings.reduce(
    (prevString, nextString, index) =>
      prevString + (index > 0 ? values[index - 1] : "") + nextString,
    ""
  );
  return r;
}

export default ({ path, as, culture, ...args }) => {
  const dictEntry = get(
    dict,
    `${culture}.${path}`,
    "** translation not found! **"
  );

  const entryString =
    typeof dictEntry === "string" ? dictEntry : dictEntry(args);

  return translate`${entryString}`;
};
